module.exports = __webpack_public_path__ + "media/Video 10bv2.ec58cfaa.mp4";